module.exports = __webpack_public_path__ + "media/images/C&W2017-72a0020f3cd001ec3e6c406b9d89312c.png";